import NftWallets from './src/main';
export default NftWallets;